<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from 'cn'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <h5 :class="cn('text-sm font-semibold tracking-tight', props.class)">
    <slot />
  </h5>
</template>
